import { NgInject } from '@df/ng/ng-inject';
import { BasketItem, basketItemFactory } from '@df/session/api/basket/basket-item';
import { CustomerModel } from '@df/session/api/customer.model';
import { CustomerModelDecorator } from '../api/customer.model.decorator';

declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketItem {
            coupon_discount?: number;
        }
    }
}

export class BasketItemDecorator extends BasketItem {
    @NgInject(CustomerModel)
    private customerModel!: CustomerModelDecorator;

    override get price(): number {
        const price = this.data.price;
        if (this.customerModel.isStaff && price) {
            return (price * 100 - this.couponDiscountPerItem * 100) / 100;
        }
        return price;
    }

    private get couponDiscountPerItem(): number {
        const discount = this.data?.coupon_discount;
        if (discount) {
            const qty = this.data.request.qty;
            if (qty) {
                return discount / qty;
            }
        }
        return 0;
    }
}

basketItemFactory.instance = BasketItemDecorator;
